import { render, staticRenderFns } from "./subCommercialGrade.vue?vue&type=template&id=4f1a71db&scoped=true"
import script from "./subCommercialGrade.vue?vue&type=script&lang=js"
export * from "./subCommercialGrade.vue?vue&type=script&lang=js"
import style0 from "./subCommercialGrade.vue?vue&type=style&index=0&id=4f1a71db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1a71db",
  null
  
)

export default component.exports